import { useEffect, useState } from 'react';
import { getBussinesList } from '../../../../services/bussines';
import { ImoduleFilter } from '../../../../types/global';
import { IBussinesDetail } from '../../../../types/bussines';
import { displayErrorNotification } from '../../../../utils/displayNudosStandardNotifications';
import useDebounce from '../../../../hooks/useDebounce';
import useFiltersState from '../../../../state/useFiltersState';
import SearchBar from '../../../../components/searchBar/SearchBar';
import { useHistory } from 'react-router-dom';

import './InviteEmailToOrganization.scss';

const InviteEmailToOrganization = () => {
  const { bussinesFilters } = useFiltersState();
  const [searchText, setSearchText] = useState<string>('');
  const [dataBussines, setDataBussines] = useState<IBussinesDetail[]>([]);
  const [loading, setLoading] = useState<boolean>(false);
  const productDebounce = useDebounce(searchText, 1000);
  const loaderCards = Array(50).fill('.');

  const { push } = useHistory();

  const getData = async (search?: string, noLoading?: boolean, bussinesFilters?: ImoduleFilter[]) => {
    if (!noLoading) {
      setLoading(true);
    }
    const searchIdentifier = bussinesFilters && bussinesFilters?.length > 0 && search ? '&' : '?';

    const filters =
      bussinesFilters && bussinesFilters.length > 0
        ? `${searchIdentifier}filters=${JSON.stringify(bussinesFilters)}`
        : '';
    try {
      const data = await getBussinesList(search, filters);
      setDataBussines([...data]);
      setLoading(false);
    } catch (error) {
      displayErrorNotification();
      setLoading(false);
    }
  };

  const sendToOrganizationDetails = (id: number) => {
    if (!id) return;
    push(`/organization/details/${id}?enableSupportActions=true`);
  };
  useEffect(() => {
    getData(productDebounce, false, bussinesFilters);
  }, [productDebounce, bussinesFilters]);

  return (
    <div id="inviteEmailToOrganization">
      <div className="searchBarContainer">
        <SearchBar setSearchText={setSearchText} customPlaceholder="Buscar Empresa" />
      </div>
      <div className="bodyCardsOrganizations">
        {loading &&
          loaderCards.map(card => {
            return <div className="bussinesCardItemLoader animationLoader"></div>;
          })}
        {!loading &&
          dataBussines &&
          dataBussines.length > 0 &&
          dataBussines.map(bussines => {
            return (
              <div
                className="bussinesCardItem"
                onClick={() => {
                  sendToOrganizationDetails(bussines.id);
                }}
              >
                <div className="idText">ID: {bussines.id}</div>
                <div className="bussinesName">Nombre: {bussines.name} </div>
                <div className="containerCountryFlag">
                  <div className="flagImage" style={{ backgroundImage: `url("${bussines?.country?.flag}")` }} />
                  <div className="textCountryCode">{bussines.countryCode}</div>
                </div>
              </div>
            );
          })}
      </div>
    </div>
  );
};

export default InviteEmailToOrganization;
